import type { VariantType, Options } from 'motion-v';

type MotionTransition = Options['transition'];
type Variants = Record<string, VariantType>;

const EASE_POWER2_OUT = [0.25, 0.46, 0.45, 0.94] as const;

export const fadeUpVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
};

export const quickTransition: MotionTransition = {
    duration: 0.4,
    ease: EASE_POWER2_OUT,
};

export const cardStagger: MotionTransition = {
    staggerChildren: 0.1,
    delayChildren: 0.15,
};

export const sectionTransition = (index: number): MotionTransition => ({
    duration: 0.4,
    ease: EASE_POWER2_OUT,
    delay: 0.1 + index * 0.12,
});
